import { render, staticRenderFns } from "./RepairAssessmentDetail.vue?vue&type=template&id=c023a0ca&scoped=true"
import script from "./RepairAssessmentDetail.vue?vue&type=script&lang=js"
export * from "./RepairAssessmentDetail.vue?vue&type=script&lang=js"
import style0 from "./RepairAssessmentDetail.vue?vue&type=style&index=0&id=c023a0ca&prod&lang=scss&scoped=true"
import style1 from "./RepairAssessmentDetail.vue?vue&type=style&index=1&id=c023a0ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c023a0ca",
  null
  
)

export default component.exports